/*
 *  Document   : app.js
 *  Author     : pixelcave
 *  Description: Custom scripts and plugin initializations (available to all pages)
 *
 *  Feel free to remove the plugin initilizations from uiInit() if you would like to
 *  use them only in specific pages. Also, if you remove a js plugin you won't use, make
 *  sure to remove its initialization from uiInit().
 */

/* Helper variables - set in uiInit() */
let page, pageContent, header, sidebar, sBrand, sExtraInfo, sidebarAlt, sScroll, sScrollAlt;

/* Initialization UI Code */
let uiInit = function () {

    // Set variables - Cache some often used Jquery objects in variables */
    page = $('#page-container');
    header = $('header');
    pageContent = $('#page-content');

    sidebar = $('#sidebar');
    sBrand = $('#sidebar-brand');
    sExtraInfo = $('#sidebar-extra-info');
    sScroll = $('#sidebar-scroll');

    sidebarAlt = $('#sidebar-alt');
    sScrollAlt = $('#sidebar-scroll-alt');

    // Initialize sidebars functionality
    handleSidebar('init');

    // Sidebar navigation functionality
    handleNav();

    // Header glass effect on scrolling
    if ((header.hasClass('navbar-fixed-top') || header.hasClass('navbar-fixed-bottom'))) {
        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 50) {
                header.addClass('navbar-glass');
            } else {
                header.removeClass('navbar-glass');
            }
        });
    }

    // Resize #page-content to fill empty space if exists
    $(window).on('resize orientationchange', function () {
        resizePageContent();
    }).resize();

    // Add the correct copyright year
    let yearCopy = $('#year-copy'), d = new Date();
    if (d.getFullYear() === 2014) {
        yearCopy.html('2014');
    } else {
        yearCopy.html('2014-' + d.getFullYear().toString().substr(2, 2));
    }

    // Initialize Tabs
    $('[data-toggle="tabs"] a, .enable-tabs a').click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });

    // Initialize image gallery lightbox
    $('[data-toggle="lightbox-gallery"]').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                arrowMarkup: '<button type="button" class="mfp-arrow mfp-arrow-%dir%" title="%title%"></button>',
                tPrev: 'Previous',
                tNext: 'Next',
                tCounter: '<span class="mfp-counter">%curr% of %total%</span>'
            },
            image: {titleSrc: 'title'}
        });
    });
    // Toggles 'open' class on toggle menu
    $('.toggle-menu .submenu').on('click', function () {
        $(this)
            .parent('li')
            .toggleClass('open');
    });

};

/* Page Loading functionality */
let pageLoading = function () {
    let pageWrapper = $('#page-wrapper');

    if (pageWrapper.hasClass('page-loading')) {
        if (page.hasClass('enable-cookies')) {
            setTimeout(function () {
                pageWrapper.removeClass('page-loading');
            }, 100);
        } else {
            pageWrapper.removeClass('page-loading');
        }
    }
};

/* Sidebar Navigation functionality */
let handleNav = function () {
    // Get all vital links
    let allLinks = $('.sidebar-nav a', sidebar);
    let menuLinks = $('.sidebar-nav-menu', sidebar);
    let submenuLinks = $('.sidebar-nav-submenu', sidebar);

    // Add ripple effect to all navigation links
    allLinks.on('click', function (e) {
        let link = $(this), ripple, d, x, y;

        // Remove .animate class from all ripple elements
        sidebar.find('.sidebar-nav-ripple').removeClass('animate');

        // If the ripple element doesn't exist in this link, add it
        if (link.children('.sidebar-nav-ripple').length === 0) {
            link.prepend('<span class="sidebar-nav-ripple"></span>');
        }

        // Get the ripple element
        ripple = link.children('.sidebar-nav-ripple');

        // If the ripple element doesn't have dimensions set them accordingly
        if (!ripple.height() && !ripple.width()) {
            d = Math.max(link.outerWidth(), link.outerHeight());
            ripple.css({height: d, width: d});
        }

        // Get coordinates for our ripple element
        x = e.pageX - link.offset().left - ripple.width() / 2;
        y = e.pageY - link.offset().top - ripple.height() / 2;

        // Position the ripple element and add the class .animate to it
        ripple.css({top: y + 'px', left: x + 'px'}).addClass('animate');
    });

    // Primary Accordion functionality
    menuLinks.on('click', function (e) {
        let link = $(this);
        let windowW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        // If we are in mini sidebar mode
        if (page.hasClass('sidebar-visible-lg-mini') && (windowW > 991)) {
            if (link.hasClass('open')) {
                link.removeClass('open');
            }
            else {
                $('#sidebar .sidebar-nav-menu.open').removeClass('open');
                link.addClass('open');
            }
        }
        else if (!link.parent().hasClass('active')) {
            if (link.hasClass('open')) {
                link.removeClass('open');
            }
            else {
                $('#sidebar .sidebar-nav-menu.open').removeClass('open');
                link.addClass('open');
            }

            // Resize Page Content
            setTimeout(resizePageContent, 50);
        }

        return false;
    });

    // Submenu Accordion functionality
    submenuLinks.on('click', function (e) {
        let link = $(this);

        if (link.parent().hasClass('active') !== true) {
            if (link.hasClass('open')) {
                link.removeClass('open');
            }
            else {
                link.closest('ul').find('.sidebar-nav-submenu.open').removeClass('open');
                link.addClass('open');
            }

            // Resize Page Content
            setTimeout(resizePageContent, 50);
        }

        return false;
    });
};

/* Sidebars Functionality */
let handleSidebar = function (mode) {
    if (mode === 'init') {
        // Init sidebars scrolling functionality
        handleSidebar('sidebar-scroll');
        handleSidebar('sidebar-alt-scroll');

        // Handle main sidebar's scrolling functionality on resize or orientation change
        let sScrollTimeout;

        $(window).on('resize orientationchange', function () {
            clearTimeout(sScrollTimeout);

            sScrollTimeout = setTimeout(function () {
                handleSidebar('sidebar-scroll');
            }, 150);
        });
    } else {
        let windowW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (mode === 'toggle-sidebar') {
            if (windowW > 991) { // Toggle main sidebar in large screens (> 991px)
                if (page.hasClass('sidebar-visible-lg-full')) {
                    page.removeClass('sidebar-visible-lg-full').addClass('sidebar-visible-lg-mini');
                } else if (page.hasClass('sidebar-visible-lg-mini')) {
                    page.removeClass('sidebar-visible-lg-mini').addClass('sidebar-visible-lg-full');
                } else {
                    page.addClass('sidebar-visible-lg-mini');
                }

                // Resize Page Content
                setTimeout(resizePageContent, 50);
            } else { // Toggle main sidebar in small screens (< 992px)
                page.toggleClass('sidebar-visible-xs');

                if (page.hasClass('sidebar-visible-xs')) {
                    handleSidebar('close-sidebar-alt');
                }
            }

            // Handle main sidebar scrolling functionality
            handleSidebar('sidebar-scroll');
        }
        else if (mode === 'open-sidebar') {
            if (windowW > 991) { // Open main sidebar in large screens (> 991px)
                page.removeClass('sidebar-visible-lg-mini').addClass('sidebar-visible-lg-full');
            } else { // Open main sidebar in small screens (< 992px)
                page.addClass('sidebar-visible-xs');
                handleSidebar('close-sidebar-alt');
            }
            // Handle main sidebar scrolling functionality
            handleSidebar('sidebar-scroll');

            // Resize Page Content
            setTimeout(resizePageContent, 50);
        }
        else if (mode === 'close-sidebar') {
            if (windowW > 991) { // Close main sidebar in large screens (> 991px)
                page.removeClass('sidebar-visible-lg-full').addClass('sidebar-visible-lg-mini');
            } else { // Close main sidebar in small screens (< 992px)
                page.removeClass('sidebar-visible-xs');
            }

            // Handle main sidebar scrolling functionality
            handleSidebar('sidebar-scroll');
        }
        else if (mode === 'toggle-sidebar-alt') {
            if (windowW > 991) { // Toggle alternative sidebar in large screens (> 991px)
                page.toggleClass('sidebar-alt-visible-lg');
            } else { // Toggle alternative sidebar in small screens (< 992px)
                page.toggleClass('sidebar-alt-visible-xs');

                if (page.hasClass('sidebar-alt-visible-xs')) {
                    handleSidebar('close-sidebar');
                }
            }
        }
        else if (mode === 'open-sidebar-alt') {
            if (windowW > 991) { // Open alternative sidebar in large screens (> 991px)
                page.addClass('sidebar-alt-visible-lg');
            } else { // Open alternative sidebar in small screens (< 992px)
                page.addClass('sidebar-alt-visible-xs');
                handleSidebar('close-sidebar');
            }
        }
        else if (mode === 'close-sidebar-alt') {
            if (windowW > 991) { // Close alternative sidebar in large screens (> 991px)
                page.removeClass('sidebar-alt-visible-lg');
            } else { // Close alternative sidebar in small screens (< 992px)
                page.removeClass('sidebar-alt-visible-xs');
            }
        }
        else if (mode === 'sidebar-scroll') { // Handle main sidebar scrolling
            if (page.hasClass('sidebar-visible-lg-mini') && (windowW > 991)) { // Destroy main sidebar scrolling when in mini sidebar mode
                if (sScroll.length && sScroll.parent('.slimScrollDiv').length) {
                    sScroll
                        .slimScroll({destroy: true});
                    sScroll
                        .attr('style', '');
                }
            }
            else if ((header.hasClass('navbar-fixed-top') || header.hasClass('navbar-fixed-bottom'))) {
                let sHeight = window.innerHeight - ((sBrand.css('display') === 'none' ? 0 : sBrand.outerHeight()) + (sExtraInfo.css('display') === 'none' ? 0 : sExtraInfo.outerHeight()));

                if (windowW < 992) {
                    sHeight = sHeight - 50;
                }

                if (sScroll.length && (!sScroll.parent('.slimScrollDiv').length)) { // If scrolling does not exist init it..
                    sScroll
                        .slimScroll({
                            height: sHeight,
                            color: '#bbbbbb',
                            size: '3px',
                            touchScrollStep: 100,
                            railVisible: false,
                            railOpacity: 1
                        });
                }
                else { // ..else resize scrolling height
                    sScroll
                        .add(sScroll.parent())
                        .css('height', sHeight);
                }
            }
        }
        else if (mode === 'sidebar-alt-scroll') { // Init alternative sidebar scrolling
            if (sScrollAlt.length && (!sScrollAlt.parent('.slimScrollDiv').length)) { // If scrolling does not exist init it..
                sScrollAlt.slimScroll({
                    height: sidebarAlt.outerHeight(),
                    color: '#bbbbbb',
                    size: '3px',
                    touchScrollStep: 100,
                    railVisible: false,
                    railOpacity: 1
                });

                // Resize alternative sidebar scrolling height on window resize or orientation change
                let sScrollAltTimeout;

                $(window).on('resize orientationchange', function () {
                    clearTimeout(sScrollAltTimeout);

                    sScrollAltTimeout = setTimeout(function () {
                        handleSidebar('sidebar-alt-scroll');
                    }, 150);
                });
            }
            else { // ..else resize scrolling height
                sScrollAlt.add(sScrollAlt.parent()).css('height', sidebarAlt.outerHeight());
            }
        }
    }
};

/* Resize #page-content to fill empty space if exists */
let resizePageContent = function () {
    let windowH = window.innerHeight;
    let headerH = header.outerHeight();
    let sidebarH = sidebar.outerHeight();

    if (header.hasClass('navbar-fixed-top') || header.hasClass('navbar-fixed-bottom')) {
        pageContent.css('min-height', windowH);
    } else if (sidebarH > windowH) {
        pageContent.css('min-height', sidebarH - headerH);
    } else {
        pageContent.css('min-height', windowH - headerH);
    }
};

export default {
    init: function () {
        uiInit(); // Initialize UI
        pageLoading(); // Initialize Page Loading
    },
    sidebar: function (mode, extra) {
        handleSidebar(mode, extra); // Handle sidebars - access functionality from everywhere
    },
    isLoading: function (show) {
        $(".ns-loading").css('visibility', show ? 'visible' : 'hidden');
    }
};